export const FORA_REPORTER_NAME = 'Fora';
export const KS_ADMIN_ROLE = 'KS_ADMIN';
export const MAX_NUMBER_OF_DIGITS_PAY_AMOUNT = 8;
